import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {Button} from '@vio/atlas/src/components/designSystem/Button'
import {Divider} from '@vio/atlas/src/components/designSystem/Divider'
import {Icon} from '@vio/atlas/src/components/designSystem/Icon'
import {Text} from '@vio/atlas/src/components/designSystem/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

const Wrapper = styled(Box)`
  flex: 2;
`

export const HotelQuestionHeader = ({onClose}: {onClose: () => void}) => {
  return (
    <>
      <Box padding="s300" display="flex">
        <Wrapper
          display="flex"
          alignItems="center"
          gap="s300"
          justifyContent="center"
          paddingLeft="s600"
        >
          <Icon name="Sparkles2" />
          <Text variant="titleM">
            <FormattedMessageWrapper
              defaultMessage="Ask a question"
              id="chatbot.askQuestionButton"
            />
          </Text>
        </Wrapper>
        <Button onClick={onClose} variant="ghost">
          <Icon name="Close" />
        </Button>
      </Box>
      <Divider />
    </>
  )
}
